import React from 'react';

// MUI
import InputAdornment from '@mui/material/InputAdornment';

// MUI Icons
import CalculateIcon from '@mui/icons-material/Calculate';

function CalculateAdornment() {
  return (
    <InputAdornment position='end'>
      <CalculateIcon color='disabled' />
    </InputAdornment>
  );
}

export default CalculateAdornment;
